module.exports = __webpack_public_path__ + "static/img/background.0099128a.png";